module.exports = __webpack_public_path__ + "assets/img/btn-login-sumbit@3x.9401da98.png";